var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGarlicParm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "garlic-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1396092,27.9881097 C10.1396092,27.9881097 8.35,27.4519085 8.35,24.9466071 C8.35,21.6839594 15.8015298,19.0502878 16.1207513,16.1223872 C16.1207513,16.1223872 16.2926689,16.6548016 16.2388973,17.518555 C15.9787489,21.7078158 10.1396092,25.4426689 10.1396092,27.9881097 Z M28.096289,32.4761436 C27.0076038,32.4761436 25.8242502,31.8134656 25.8242502,31.8134656 C25.8242502,31.8134656 25.8954408,30.6569979 25.8954408,29.044229 C25.8954408,26.2874886 22.3923357,24.1453347 21.6274159,19.806498 L21.4827628,18.9772039 C21.4827628,24.6482127 25.088867,25.7857467 25.088867,29.454332 C25.088867,32.2394729 24.2622236,35 21.2858528,35 C17.8834747,35 16.826598,32.5761133 16.826598,32.5761133 C16.826598,32.5761133 11.23814,33.3497425 11.23814,28.0237049 C11.23814,23.2933202 18.4086943,25.155256 18.4321721,5 L19.4341412,7.3534535 L21.3998334,5.96902454 C21.3998334,5.96902454 20.906801,6.61996365 20.906801,10.3661769 C20.906801,18.3073311 31.6455922,21.8892002 31.6455922,27.3197516 C31.6455922,31.6305665 29.1849743,32.4761436 28.096289,32.4761436 Z",
    id: "garlic-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "garlic-icon-/-Flavor-/-GarlicParm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "garlic-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "garlic-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "garlic-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "garlic-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#garlic-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "garlic-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#garlic-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "garlic-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#garlic-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "garlic-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#garlic-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "garlic-Combined-Shape",
    fill: "#231F20",
    xlinkHref: "#garlic-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "garlic-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#garlic-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarlicParm);
export default __webpack_public_path__ + "static/media/GarlicParm.e1a8634403121798d37619033955060b.svg";
export { ForwardRef as ReactComponent };